<template>
	<img
		:src="src"
		alt="Thumbnail"
		:class="`image image--orientation-${orientation}`"
	/>
</template>
<script>
	export default {
		name: 'ImageExif',
		props: {
			src: {
				required: true,
			},
		},
		data() {
			return {
				orientation: 1,
			};
		},
		mounted() {
			const hasOrientation = this.src.split('_orientation_').length === 2;

			if (hasOrientation) {
				const orientation = Number(
					this.src.split('_orientation_').pop().split('.').shift()
				);

				if (!isNaN(orientation)) {
					this.orientation = orientation;
				}
			}
		},
	};
</script>
<style lang="scss" scoped>
	IMG {
		.image--orientation-2 {
			transform: scale(-1, 1);
		}

		.image--orientation-4 {
			transform: scale(-1, 1) rotate(180deg);
		}

		.image--orientation-5 {
			transform: scale(-1, 1) rotate(90deg);
		}

		.image--orientation-7 {
			transform: scale(-1, 1) rotate(-90deg);
		}

		.image--orientation-3 {
			transform: rotate(180deg);
		}

		.image--orientation-6 {
			transform: rotate(90deg);
		}

		.image--orientation-8 {
			transform: rotate(180deg);
		}
	}
</style>
